import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ThemeProvider } from "@/context/ThemeProvider";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Features } from "@/components/Features";
import { Manifesto } from "@/components/Manifesto";
import { Integrations } from "@/components/Integrations";
import { Pricing } from "@/components/Pricing";
import { CTA } from "@/components/CTA";
import { Footer } from "@/components/Footer";
import { LoadingScreen } from "@/components/LoadingScreen";
import { RefundPolicy } from "@/pages/RefundPolicy";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { TermsConditions } from "@/pages/TermsConditions";

function Landing() {
  const [phase, setPhase] = useState("show");
  useSmoothScroll();

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("fade"), 1200);
    const t2 = setTimeout(() => setPhase("gone"), 1800);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <div className="App relative min-h-screen bg-bg text-ink">
      <div className="noise-overlay" />
      {phase !== "gone" && <LoadingScreen fading={phase === "fade"} />}
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Features />
        <Manifesto />
        <Integrations />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
